import type { AppShellHeaderConfiguration } from '@mantine/core';
import { createStore, useSelector } from '@tanstack/react-store';
import { useMemo } from 'react';

interface HeaderState extends Omit<AppShellHeaderConfiguration, 'height'> {
	isFixed: boolean;
}

export const headerStore = createStore<HeaderState>({
	isFixed: false,
});

export function initializeHeader(config: Partial<HeaderState>) {
	headerStore.setState(prev => ({
		...prev,
		...config,
	}));
}

export function useHeaderIsFixed() {
	const fixedState = useSelector(headerStore, x => x.isFixed);

	return useMemo(
		() => ({
			isFixed: fixedState,
		}),
		[fixedState],
	);
}
